//* 로그인, 회원가입 등 계정 관련 Page에서 사용되는 기본적인 Input
import React, { InputHTMLAttributes, useState } from 'react';

import { EyeIcon, EyeOffIcon } from '@heroicons/react/outline';
import { FieldValues, UseFormRegister } from 'react-hook-form';

// tailwindcss classname을 inline으로 사용해 JSX 부분의 가독성이 떨어지는것 방지
const classNames = {
  signupInput:
    'relative mt-1 h-11 w-full rounded-none border border-gray-300 py-3 pl-4 text-15 font-bold theme-bg-1 focus:theme-border-main sm:text-sm',
};

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  registerName: string;
  text?: string;
  type?: React.HTMLInputTypeAttribute | undefined;
  inputClassName?: string;
  register: UseFormRegister<FieldValues>;
  /** type="password"일 때 입력값 보기/숨기기 토글 버튼 노출 */
  passwordToggle?: boolean;
}
const AccountInput: React.FC<InputProps> = ({
  registerName,
  text,
  type,
  placeholder = '',
  className = '',
  inputClassName,
  register,
  passwordToggle = false,
  ...props
}: InputProps) => {
  // tailwindcss classname
  const { signupInput } = classNames;
  const [revealed, setRevealed] = useState(false);

  const hasToggle = passwordToggle && type === 'password';
  const inputType = hasToggle && revealed ? 'text' : type;
  const ToggleIcon = revealed ? EyeOffIcon : EyeIcon;

  return (
    <div className={`relative mt-2 text-15 ${className}`}>
      <input
        type={inputType}
        className={`${signupInput} ${inputClassName ?? ''} rounded-lg bg-[#F9FAFB] ${
          hasToggle ? 'pr-11' : ''
        }`}
        placeholder={placeholder}
        autoComplete="off"
        autoCapitalize="off"
        {...props}
        {...register(registerName)}
      />
      {hasToggle && (
        <button
          type="button"
          // 입력 포커스·커서 위치 유지
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => setRevealed((prev) => !prev)}
          disabled={props.disabled}
          aria-label={revealed ? '비밀번호 숨기기' : '비밀번호 보기'}
          aria-pressed={revealed}
          className="absolute bottom-0 right-0 top-1 flex w-11 items-center justify-center text-gray-400 disabled:opacity-50"
        >
          <ToggleIcon className="h-5 w-5" />
        </button>
      )}
    </div>
  );
};

export { AccountInput };
